import { z } from 'zod';

export const DeliveryArticleCategoryModelSchema = z.object({
    uid: z.string(),
    name: z.string(),
});

export type DeliveryArticleCategoryModel
= z.infer<typeof DeliveryArticleCategoryModelSchema>;
